export enum STEP_KEY {
  WELCOME = 'WELCOME',
  CONTACT = 'CONTACT',
  MEDICATIONS = 'MEDICATIONS',
  PROVIDER = 'PROVIDER',
  ALTERNATE_PROVIDER = 'ALTERNATE_PROVIDER',
  PROFILE = 'PROFILE',
  TRANSFER_INTENT = 'TRANSFER_INTENT',
  PROVIDER_INTENT = 'PROVIDER_INTENT',
  DOCTOR_INTENT = 'DOCTOR_INTENT',
  TWO_WAYS = 'TWO_WAYS',
  CONFIRMATION = 'CONFIRMATION',
  DEPENDENTS = 'DEPENDENTS',
  CAPTCHA = 'CAPTCHA',
}

export enum STEP_NAME {
  WELCOME = 'WELCOME',
  MEDICATIONS = 'MEDICATIONS',
  PHARMACY = 'PHARMACY',
  DOCTOR = 'DOCTOR',
  PROFILE = 'PROFILE',
  CONTACT = 'CONTACT',
  JOIN_WAITLIST = 'JOIN_WAITLIST',
  WAITLIST_CONFIRMATION = 'WAITLIST_CONFIRMATION',
  ELIGIBILITY_CONFIRMATION = 'ELIGIBILITY_CONFIRMATION',
  INELIGIBLE_STEP = 'INELIGIBLE_STEP',
  WELCOME_BACK = 'WELCOME_BACK',
  TRANSFER_INTENT = 'TRANSFER_INTENT',
  PROVIDER_INTENT = 'PROVIDER_INTENT',
  DOCTOR_INTENT = 'DOCTOR_INTENT',
  CAPTCHA = 'CAPTCHA',
}

//TODO: Remove hardcoded progress bar fill percentage

export interface ProgressStep {
  key: STEP_KEY; // Key of step, should not be changed
  label: string; // Label used for progress bar
  stepName: STEP_NAME; // Main step layout of step
  additionalLayouts: STEP_NAME[]; // Additional steps outside of main flow but with the same progress bar label and step and main step
  progressBarFillPercent: number | undefined;
}

export const CAPTCHA_STEP: ProgressStep = {
  key: STEP_KEY.CAPTCHA,
  label: 'CAPTCHA',
  stepName: STEP_NAME.CAPTCHA,
  additionalLayouts: [],
  progressBarFillPercent: 20,
};

// BASE STEPS
export const MEDICATION_PROGRESS_STEP: ProgressStep = {
  key: STEP_KEY.MEDICATIONS,
  label: 'MEDICATIONS',
  stepName: STEP_NAME.MEDICATIONS,
  additionalLayouts: [],
  progressBarFillPercent: 60,
};

export const PROVIDER_PROGRESS_STEP: ProgressStep = {
  key: STEP_KEY.PROVIDER,
  label: 'PROVIDER',
  stepName: STEP_NAME.PHARMACY,
  additionalLayouts: [],
  progressBarFillPercent: 50,
};

export const PROVIDER_DOCTOR_PROGRESS_STEP: ProgressStep = {
  key: STEP_KEY.PROVIDER,
  label: 'PROVIDER',
  stepName: STEP_NAME.DOCTOR,
  additionalLayouts: [],
  progressBarFillPercent: 50,
};

// INTENT STEPS
export const TRANSFER_INTENT_PROGRESS_STEP: ProgressStep = {
  key: STEP_KEY.TRANSFER_INTENT,
  label: 'TRANSFER INTENT',
  stepName: STEP_NAME.TRANSFER_INTENT,
  additionalLayouts: [],
  progressBarFillPercent: 40,
};

export const PROVIDER_INTENT_PROGRESS_STEP: ProgressStep = {
  key: STEP_KEY.PROVIDER_INTENT,
  label: 'PROVIDER INTENT',
  stepName: STEP_NAME.PROVIDER_INTENT,
  additionalLayouts: [],
  progressBarFillPercent: 40,
};

export const DOCTOR_INTENT_PROGRESS_STEP: ProgressStep = {
  key: STEP_KEY.DOCTOR_INTENT,
  label: 'DOCTOR INTENT',
  stepName: STEP_NAME.DOCTOR_INTENT,
  additionalLayouts: [],
  progressBarFillPercent: 40,
};

/**
 * DEFAULT_ONBOARDING_STEPS
 * Maps the layouts for progress bar tracking
 * Index of ProgressStep in the array is the step number on the progress bar
 *
 * key: Unique key used for selecting the step and updating label and/or stepName
 * label: Label for progress bar
 * stepName is the main layout for that index
 * additionalLayouts: steps outside of the main flow but still mapped on the progress bar
 */
export const DEFAULT_ONBOARDING_STEPS: ProgressStep[] = [
  {
    key: STEP_KEY.WELCOME,
    label: 'WELCOME',
    stepName: STEP_NAME.WELCOME,
    additionalLayouts: [STEP_NAME.ELIGIBILITY_CONFIRMATION, STEP_NAME.INELIGIBLE_STEP],
    progressBarFillPercent: 10,
  },
  {
    key: STEP_KEY.CONTACT,
    label: 'CONTACT',
    stepName: STEP_NAME.CONTACT,
    additionalLayouts: [STEP_NAME.JOIN_WAITLIST],
    progressBarFillPercent: 20,
  },
  PROVIDER_PROGRESS_STEP,
  MEDICATION_PROGRESS_STEP,
  {
    key: STEP_KEY.PROFILE,
    label: 'PROFILE',
    stepName: STEP_NAME.PROFILE,
    additionalLayouts: [],
    progressBarFillPercent: 80,
  },
];
